import { Injectable } from "@angular/core";
import { Colectivo } from "../app.domain.models/colectivo";
import { ColectivoQuery } from "../app.domain.queries/colectivo.query";
import { ColectivoRepository } from "../app.domain.repository/colectivo.repository";
import { ConfiguracionMostrarToast } from "../core.models/configuracion-mostrar-toast";
import { GenericEntityService } from "../core.utilidades/generic-entity.service";
import { getGQLQueryString } from "../core.utilidades/graphql-utils";

@Injectable({
    providedIn: 'root',
})
export class ColectivoApiService extends ColectivoRepository implements GenericEntityService<Colectivo> {

    actualizarColectivo(instancia: Colectivo, configToast?: ConfiguracionMostrarToast): Promise<Colectivo> {
        if (instancia['enlace']){
            delete instancia['enlace'];
        }
        const variables = { instancia };
        return this.apiService.query(getGQLQueryString(ColectivoQuery.actualizar, variables), variables, configToast);
    }
    
}
